export const STATE_LABELS: Record<string, string> = {
  procured: 'Procured', in_stock: 'In stock', assigned: 'Assigned', in_service: 'In service',
  under_repair: 'Under repair', awaiting_parts: 'Awaiting parts', returned: 'Returned',
  retired: 'Retired', disposed: 'Disposed',
};

export const REPAIR_LABELS: Record<string, string> = {
  raised: 'Raised', triaged: 'Triaged', dispatched: 'Dispatched', in_repair: 'In repair',
  awaiting_parts: 'Awaiting parts', completed: 'Completed', cancelled: 'Cancelled',
};

export const words = (v: string): string => v.replace(/_/g, ' ').replace(/^./, (c) => c.toUpperCase());

export const stateLabel = (s: string): string => STATE_LABELS[s] ?? words(s);

export const repairLabel = (s: string): string => REPAIR_LABELS[s] ?? words(s);

export const rupees = (minor: number | null | undefined): string =>
  minor === null || minor === undefined ? '—' : '₹' + (minor / 100).toLocaleString('en-IN');
